<template>
  <div id="app">
    <!-- Import the Navbar--> 
    <NavBar />
    <Intro  />
    <Domain class="section-block"  />
    <!-- Skills section -->
    <Skill class="section-block"  />
    <!-- Portfolio section -->
    <Portfolio class="section-block"  />
    <!-- contribution section -->
    <Contribution class="section-block"  />
    <!-- Footer which is also the contact section-->
    <Footer />
    <!-- Copyright-->
    <section class="copyright py-4 text-center text-white">
    <div class="container">
      <small>Copyright © Brice Friha 2020</small>
    </div>
  </section>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Intro from './components/Intro.vue'
import Footer from './components/Footer.vue'
import Skill from './components/Skill.vue'
import Domain from './components/Domain.vue';
import Contribution from './components/Contribution.vue';
import Portfolio from './components/Portfolio.vue';

export default {
  name: 'App',
  components: {
    NavBar,
    Intro,
    Footer,
    Skill,
    Domain,
    Contribution,
    Portfolio,
  },
  data(){
    return{
      sectionTitleStyle: {
          center: true,
          color: '#1a1a1a',
          class: 'masthead-heading'
        },
      sectionSubtitleStyle: {
          center: true,
          color: '#1a1a1a',
          class: 'masthead-heading'
          
      },
      sectionStyle: {
          margin: 10
          
      },
    }
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
section{
  background-color: black;
}
.section-block {
  margin-bottom: 20px ;
  padding-top: 80px;
}
</style>
